<template>

    <component
        v-if="ready"
        :is="currentComponent"
        :args="currentArgs"
        ref="page"
        @change-screen="onChangeScreen"
        @reset-args="onResetArgs"
    />

</template>


<script>
export default {
    name       : 'Profile Module',
    components : [],
}
</script>


<script setup>
import { computed, ref, onMounted, inject, shallowRef } from "vue";
import { useStore }                                     from "vuex";
import Profile                                          from "./components/Profile.vue";
import ProfileWizard                                    from "./components/ProfileWizard.vue";
import { scrollToTopOfProfile }                         from './composables/UseCopydeck';

//init
let store                     = useStore();
const injectedCopydeck        = inject( 'copydeck' );
const injectedProfileForms    = inject( 'profileForm' );
const injectedThemes          = inject( 'themes' );
const injectedUser            = inject( 'user' );
const injectedAvatars         = inject( 'avatars' );
const injectedAvatarFrames    = inject( 'avatarFrames' );
const injectedDefaultAvatarId = inject( 'defaultAvatarId' );


//COMPUTED
let ready = computed( () => store.state.ready );
let user  = computed( () => store.state.user );

let screen              = ref( null );
let availableComponents = { "profile" : Profile, "profile-wizard" : ProfileWizard };
let currentComponent    = shallowRef( null );
let currentArgs         = ref( {} )
let page                = ref( null );



function onChangeScreen ( newScreen, args = {} )
{
    screen.value           = newScreen;
    currentComponent.value = availableComponents[ screen.value ];
    currentArgs.value      = args;

    setBodyClassBasedOnScreen( screen.value );
    scrollToTopOfProfile();

}

function onResetArgs ( strArg )
{
    if ( strArg in currentArgs.value )
    {
        delete currentArgs.value[ strArg ]
    }
}

function onProfileChanged (event)
{

    const data = event.data;

    if ("email" in  data)
    {
        store.commit("email", data.email);

        if (page.clearError)
        {
            page.clearError("email");
        }
    }
}

async function mounted ()
{

    store.commit( 'copydeck', injectedCopydeck );
    store.commit( 'form', injectedProfileForms );

    let userInfo = {name: injectedUser.name, email: injectedUser.email};

    injectedUser.profile = Object.assign(injectedUser.profile ?? {}, userInfo);

    store.commit( 'user', injectedUser );
    store.commit( 'datastore', { key : "themes", data : injectedThemes } );

    store.commit( 'avatars', injectedAvatars );
    store.commit( 'avatarFrames', injectedAvatarFrames );
    store.commit( 'defaultAvatarId', injectedDefaultAvatarId );

    store.commit( "ready" );

    let isProfileCompleted = user.value.profile?.completed_profile ?? false;
    onChangeScreen( isProfileCompleted ? "profile" : "profile-wizard" );



}


onMounted( mounted );


function setBodyClassBasedOnScreen ( screen )
{

    const body = document.querySelector( 'body' );

    if ( "profile-wizard" === screen )
    {
        body.classList.remove( "profile-mode_profile" );
        body.classList.add( "profile-mode_profile-wizard" );
    } else
    {
        body.classList.remove( "profile-mode_profile-wizard" );
        body.classList.add( "profile-mode_profile" );
    }


}

</script>


